export function isBelforEmailAddress(emailAdress: string | null | undefined) {
  if (!emailAdress) {
    return false;
  }

  const tokens = emailAdress.split("@");

  if (tokens.length < 2) {
    return false;
  }

  const domain = tokens[1];

  return domain.includes("belfor");
}

export function isSvtEmailAddress(emailAdress: string | null | undefined) {
  if (!emailAdress) {
    return false;
  }

  const tokens = emailAdress.split("@");

  if (tokens.length < 2) {
    return false;
  }

  const domain = tokens[1];

  return domain.includes("svt");
}

export function validateEmailAddresses(emails: string): boolean {
  const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const emailArray = emails.split(";");

  for (const email of emailArray) {
    if (!emailRegex.test(email.trim())) {
      return false;
    }
  }

  return true;
}